export const en = {
  signInToYourAccount: 'Sign in to your account',
  welcomeBackWeAreLuckyToHaveYou: 'Welcome back, we are lucky to have you.',
  donTHaveAnAccount: "Don't have an account?",
  signUp: 'Sign up',
  uhOhLooksLikeYouReMissingAToken: "Uh oh! Looks like you're missing a token",
  itSeemsThatThereIsNoTokenProvidedIf:
    'It seems that there is no token provided, if you are trying to verify your email please follow the link in your email.',
  goBackHome: 'Go back home',
  forgotYourPassword: 'Forgot your password?',
  noWorriesItHappensEnterYourEmailAndWe:
    "No worries, it happens! Enter your email and we'll email you a special link to reset your password.",
  rememberedYourPassword: 'Remembered your password?',
  signIn: 'Sign In',
  unableToResetPassword: 'Unable to reset password',
  theTokenYouHaveUsedToResetYourPassword:
    'The token you have used to reset your password is either expired or it never existed. If you have still forgotten your password, please request a new reset link.',
  returnToSignIn: 'Return to sign in',
  somethingWentWrong: 'Something went wrong',
  weWereUnableToVerifyYourEmailAtThis: 'We were unable to verify your email at this time.',
  weWereUnableToVerifyYourEmailIfYour:
    'We were unable to verify your email. If your email is not verified already, please try again.',
  yourTokenHasExpired: 'Your token has expired!',
  itSeemsThatTheProvidedTokenHasExpiredWe:
    "It seems that the provided token has expired. We've just sent you another token, please check your email and try again.",
  emailConfirmed: 'Email Confirmed!',
  yourEmailHasBeenSuccessfullyConfirmedYouCanNow:
    'Your email has been successfully confirmed! You can now use all features of Raven.',
  continue: 'Continue',
  emailAlreadyConfirmed: 'Email already confirmed',
  yourEmailHasAlreadyBeenConfirmedYouCanNow:
    'Your email has already been confirmed. You can now use all features of Raven.',
  accountActivated: 'Account activated!',
  yourAccountHasBeenActivatedRedirecting: 'Your account has been activated. Redirecting...',
  activationFailed: 'Activation failed',
  invitationExpired: 'Invitation Expired',
  yourInvitationLinkHasExpiredPleaseContactYourOrganization:
    'Your invitation link has expired. Please contact your organization administrator to receive a new invitation.',
  goToSignIn: 'Go to Sign In',
  invalidInvitation: 'Invalid Invitation',
  thisInvitationLinkIsInvalidOrHasAlreadyBeen:
    'This invitation link is invalid or has already been used.',
  accountActivated2: 'Account Activated!',
  yourAccountHasBeenSuccessfullyActivatedYouWillBe:
    'Your account has been successfully activated. You will be redirected shortly.',
  activateYourAccount: 'Activate Your Account',
  enterYourEmailAndSetAPasswordToActivate:
    'Enter your email and set a password to activate your account.',
  emailAddress: 'Email address',
  password: 'Password',
  confirmPassword: 'Confirm password',
  activateAccount: 'Activate Account',
  alreadyHaveAnAccount: 'Already have an account?',
  signIn2: 'Sign in',
  registerNewOrganization: 'Register New Organization',
  emailSent: 'Email sent!',
  aPasswordResetEmailHasBeenSentIfYou:
    'A password reset email has been sent, if you have an account you should see it in your inbox shortly.',
  resetPassword: 'Reset Password',
  pleaseChooseYourNewPassword: 'Please choose your new password',
  confirmEmail: 'Confirm email',
  toGainAccessToYourAccountPleaseConfirmYour:
    'To gain access to your account, please confirm your email address by clicking on the confirmation link from your inbox.',
  ifYouDonTFindTheConfirmationLinkIn:
    "If you don't find the confirmation link in your inbox, you can request a new one below.",
  mustBeAtLeast6CharactersInLength: 'Must be at least 6 characters in length',
  mustBeAtLeast8CharactersInLength: 'Must be at least 8 characters in length',
  cannotBeMoreThan72CharactersInLength: 'Cannot be more than 72 characters in length',
  oneUppercaseCharacter: 'One uppercase character',
  oneLowercaseCharacter: 'One lowercase character',
  oneNumber: 'One number',
  oneSpecialCharacterIsRequired: 'One special character is required',
  firstNameIsRequired: 'First name is required',
  lastNameIsRequired: 'Last name is required',
  organizationNameIsRequired: 'Organization name is required',
  passwordsDoNotMatch: 'Passwords do not match',
  theTokenNameShouldBe3CharactersOrLonger: 'The token name should be 3 characters or longer',
  tokenCopiedToClipboard: 'Token copied to clipboard',
  theTokenWasCopiedToYourClipboard: 'The token was copied to your clipboard.',
  weWereUnableToCopyTheTokenToYour:
    'We were unable to copy the token to your clipboard. Please try again.',
  tokenCreated: 'Token created',
  aNewTokenWasCreatedSuccessfully: 'A new token was created successfully.',
  anErrorOccurred: 'An error occurred',
  tokenName: 'Token name',
  pleaseEnterAMeaningfulNameForYourTokenThis:
    'Please enter a meaningful name for your token. This will help you identify it later.',
  tokenExpirationDate: 'Token expiration date',
  choose: 'Choose...',
  neverExpire: 'Never expire',
  createToken: 'Create token',
  yourTokenWasCreatedSuccessfullyMakeSureToCopy:
    "Your token was created successfully! Make sure to copy it because you won't be able to see it again!",
  copyToken: 'Copy token',
  notSupported: 'Not supported',
  passkeysAreNotSupportedOnThisBrowser: 'Passkeys are not supported on this browser',
  unableToSignIn: 'Unable to sign in',
  thisAccountHasNotBeenVerifiedPleaseVerifyYour:
    'This account has not been verified. Please verify your account before signing in.',
  weEncounteredAnUnknownErrorWhileAttemptingToSign:
    'We encountered an unknown error while attempting to sign you In. Please try again later.',
  signingIn: 'Signing in...',
  orContinueWith: 'Or continue with',
  google: 'Google',
  twoFactorAuthentication: 'Two-Factor Authentication',
  token: 'Token',
  backupCode: 'Backup Code',
  useBackupCode: 'Use Backup Code',
  useAuthenticator: 'Use Authenticator',
  passwordShouldNotBeCommonOrBasedOnPersonal:
    'Password should not be common or based on personal information',
  registrationSuccessful: 'Registration Successful',
  youHaveSuccessfullyRegisteredPleaseVerifyYourAccountBy:
    'You have successfully registered. Please verify your account by clicking on the link you received in the email.',
  organizationName: 'Organization name',
  acmeLtd: 'Acme Ltd.',
  country: 'Country',
  optional: '(optional)',
  eGUnitedKingdom: 'e.g. United Kingdom',
  description: 'Description',
  oneOrTwoLinesAboutWhatYouDo: 'One or two lines about what you do',
  middleName: 'Middle name',
  phoneNumber: 'Phone number',
  emailAddress2: 'Email Address',
  signInInstead: 'Sign in instead',
  createAccount: 'Create account',
  byProceedingYouAgreeToOur: 'By proceeding, you agree to our',
  termsOfService: 'Terms of Service',
  and: 'and',
  privacyPolicy: 'Privacy Policy',
  resetEmailSent: 'Reset email sent',
  sendingResetEmail: 'Sending Reset Email...',
  passwordUpdated: 'Password updated',
  yourPasswordHasBeenUpdatedSuccessfully: 'Your password has been updated successfully.',
  currentPassword: 'Current Password',
  newPassword: 'New Password',
  repeatPassword: 'Repeat Password',
  updatingPassword: 'Updating password...',
  updatePassword: 'Update password',
  passwordsDonTMatch: "Passwords don't match",
  resettingPassword: 'Resetting Password...',
  back: 'Back',
  twoFactorAuthenticationDisabled: 'Two-factor authentication disabled',
  twoFactorAuthenticationHasBeenDisabledForYourAccount:
    'Two-factor authentication has been disabled for your account. You will no longer be required to enter a code from your authenticator app when signing in.',
  unableToDisableTwoFactorAuthentication: 'Unable to disable two-factor authentication',
  weWereUnableToDisableTwoFactorAuthenticationFor:
    'We were unable to disable two-factor authentication for your account. Please ensure that you have entered your password and backup code correctly and try again.',
  disable2fa: 'Disable 2FA',
  pleaseProvideATokenFromTheAuthenticatorOrA:
    'Please provide a token from the authenticator, or a backup code. If you do not have a backup code available, please contact support.',
  unableToSetupTwoFactorAuthentication: 'Unable to setup two-factor authentication',
  weWereUnableToSetupTwoFactorAuthenticationFor:
    'We were unable to setup two-factor authentication for your account. Please ensure that you have entered your code correctly and try again.',
  twoFactorAuthenticationEnabled: 'Two-factor authentication enabled',
  youWillNowBeRequiredToEnterACode:
    'You will now be required to enter a code from your authenticator app when signing in.',
  enable2fa: 'Enable 2FA',
  backupCodes: 'Backup codes',
  yourRecoveryCodesAreListedBelowPleaseStoreThem:
    'Your recovery codes are listed below. Please store them in a safe place.',
  close: 'Close',
  download: 'Download',
  enableAuthenticatorApp: 'Enable Authenticator App',
  toEnableTwoFactorAuthenticationScanTheFollowingQr:
    'To enable two-factor authentication, scan the following QR code using your authenticator app.',
  ifYourAuthenticatorAppDoesNotSupportQrCodes:
    'If your authenticator app does not support QR codes, you can use the following code instead:',
  onceYouHaveScannedTheQrCodeOrEntered:
    'Once you have scanned the QR code or entered the code manually, enter the code provided by your authenticator app below.',
  recoveryCodeCopied: 'Recovery code copied',
  yourRecoveryCodeHasBeenCopiedToYourClipboard:
    'Your recovery code has been copied to your clipboard.',
  unableToCopyRecoveryCode: 'Unable to copy recovery code',
  weWereUnableToCopyYourRecoveryCodeTo:
    'We were unable to copy your recovery code to your clipboard. Please try again.',
  tokenIsRequired: 'Token is required',
  viewCodes: 'View Codes',
  viewRecoveryCodes: 'View Recovery Codes',
  pleaseProvideATokenFromYourAuthenticatorOrA:
    'Please provide a token from your authenticator, or a backup code.',
  invalidCodePleaseTryAgain: 'Invalid code. Please try again.',
  view: 'View',
  or: 'Or',
  confirmationEmailSent: 'Confirmation email sent',
  aConfirmationEmailHasBeenSentAndItShould:
    'A confirmation email has been sent, and it should arrive in your inbox shortly.',
  anErrorOccurredWhileSendingYourConfirmationEmail:
    'An error occurred while sending your confirmation email',
  pleaseTryAgainAndMakeSureYouEnterThe:
    'Please try again and make sure you enter the correct email address.',
  sendConfirmationEmail: 'Send confirmation email',
  viewOrganizationClients: 'View Organization Clients',
  viewOrganizationAllCreatedReports: 'View Organization all created reports',
  approveRejectClients: 'Approve/Reject Clients',
  createKycAndKybReports: 'Create KYC and KYB Reports',
  viewAndManageOwnReports: 'View and manage own reports',
  viewAndManageClientsAddByThemselves: 'View and manage clients add by themselves',
  createKycReports: 'Create KYC Reports',
  createKybReports: 'Create KYB Reports',
  permissionsFor: 'Permissions for',
  briefDescriptionOfTheOrganization: 'Brief description of the organization',
  pleaseSelectAUser: 'Please select a user',
  newUser: 'New User',
  existingUser: 'Existing User',
  searchByEmail: 'Search by email...',
  searching: 'Searching...',
  noUsersFound: 'No users found',
  manageOrganizationOwnersAndTheirAccountStatus:
    'Manage organization owners and their account status',
  refresh: 'Refresh',
  allOwners: 'All Owners',
  loadingOwners: 'Loading owners...',
  failedToSendInvitation: 'Failed to send invitation',
  createOrganizationOwner: 'Create Organization & Owner',
  setUpANewOrganizationAndAssignAnOwner:
    'Set up a new organization and assign an owner in a few steps.',
  subject: 'Subject',
  body: 'Body',
  sendEmail: 'Send Email',
  invitationSentSuccessfully: 'Invitation Sent Successfully',
  theInvitationEmailWasSuccessfullySentTo: 'The invitation email was successfully sent to',
  pendingActivation: 'Pending Activation',
  exit: 'Exit',
  enterTheOrganizationSNameAndCountry: "Enter the Organization's name and country.",
  assignOwnerToOrganization: 'Assign Owner to Organization.',
  sendAnInvitationEmailToTheOwner: 'Send an invitation email to the owner.',
  pleaseReviewAndConfirmTheEmailContent: 'Please review and confirm the email content.',
  activatingTheOwnerSAccount: "Activating the owner's account",
  theOrganizationAccountWillBeActivatedUponTheOwner:
    "The organization account will be activated upon the owner's first login using the invitation email.",
  manageSystemOrganizationsAndTheirAccountStatus:
    'Manage system organizations and their account status',
  addOrganization: 'Add Organization',
  allOrganizations: 'All Organizations',
  loadingOrganizations: 'Loading organizations...',
  customizeTheAppearanceOfTheAppAutomaticallySwitchBetween:
    'Customize the appearance of the app. Automatically switch between day and night themes.',
  hereYouCanManageYourPasswordAndSecuritySettings:
    'Here you can manage your password and security settings.',
  security: 'Security',
  hereYouCanManageYourTwoFactorAuthenticationSettings:
    'Here you can manage your two factor authentication settings.',
  twoFactorAuthentication2: 'Two factor authentication',
  addAnAuthenticatorToServeAsASecondaryAuthentication:
    'Add an authenticator to serve as a secondary authentication method when signing in, or when signing documents',
  recoveryCodes: 'Recovery codes',
  twoFactorAuthenticationRecoveryCodesAreUsedToAccess:
    'Two factor authentication recovery codes are used to access your account in the event that you lose access to your authenticator app.',
  manageYourPasskeys: 'Manage your passkeys.',
  passkeys: 'Passkeys',
  onThisPageYouCanCreateAndManageApi: 'On this page, you can create and manage API tokens. See our',
  documentation: 'Documentation',
  forMoreInformation: 'for more information.',
  unauthorized: 'Unauthorized',
  youNeedToBeAnOwnerToManageApi: 'You need to be an owner to manage API tokens.',
  yourExistingTokens: 'Your existing tokens',
  yourTokensWillBeShownHereOnceYouCreate: 'Your tokens will be shown here once you create them.',
  createdOn: 'Created on',
  expiresOn: 'Expires on',
  tokenDoesnTHaveAnExpirationDate: "Token doesn't have an expiration date",
  activity: 'Activity',
  unreadNotifications: 'unread notifications',
  viewReport: 'View report ›',
  markUnread: 'Mark unread',
  markRead: 'Mark read',
  noNotificationsYet: 'No notifications yet.',
  generateNewReport: 'Generate New Report',
  backToClients: '‹ Back to Clients',
  previousClient: '‹ Previous Client',
  nextClient: 'Next Client ›',
  seeTheClientDetails: 'See The Client Details',
  comprehensiveInformationAboutTheClientReviewProgressAndSubmitted:
    'Comprehensive information about the client, review progress, and submitted documents.',
  viewLatestReport: 'View Latest Report',
  clientSections: 'Client sections',
  profile: '♙ Profile',
  keyPeople: '♧ Key People',
  reviewHistory: '◷ Review History',
  documents: '▱ Documents',
  generatedReports: '▤ Generated Reports',
  clientId: 'Client ID:',
  removeBookmark: 'Remove bookmark',
  bookmarkClient: 'Bookmark client',
  firstSubmissionDate: 'First Submission Date',
  lastReviewDate: 'Last Review Date',
  ravenReviewSummary: 'Raven Review Summary',
  riskLevelIs: 'Risk Level is:',
  generatedReports2: 'Generated Reports',
  reviewHistory2: 'Review History',
  timelineOfGeneratedReportsAndDetectedRiskLevels:
    'Timeline of generated reports and detected risk levels.',
  viewReportRiskResultsOverTime: 'View Report Risk Results Over Time',
  reviewHistoryPeriod: 'Review history period',
  riskSignalsBasedOnSelectedReport: 'Risk Signals Based on Selected Report',
  viewReport2: 'View Report ›',
  allReportsGeneratedForThisClientSReview: 'All reports generated for this client’s review.',
  savedClients: 'Saved Clients',
  allClients: 'All Clients',
  addNewClient: '+ Add New Client',
  viewAndManageTheClientsYouAreResponsibleFor:
    'View and manage the clients you are responsible for.',
  clientType: 'Client type',
  myClients: 'My Clients',
  clientsFound: 'clients found',
  viewClient: 'View client',
  noBookmarkedClients: 'No bookmarked clients.',
  noAcceptedClientsMatchYourSearch: 'No accepted clients match your search.',
  clients: 'clients',
  totalReports: 'Total Reports',
  totalClients: 'Total Clients',
  reportsInProgress: 'Reports in Progress',
  pendingReports: 'Pending Reports',
  ravenKycDashboard: 'Raven KYC Dashboard',
  welcomeBack: 'Welcome back,',
  monitorClientsKycFlowAtAGlance: 'Monitor Clients KYC flow at a glance.',
  dashboardPeriod: 'Dashboard period',
  createANewReport: 'Create a New Report',
  beginReviewingANewClient: 'Begin reviewing a new client.',
  createReport: 'Create Report',
  reportSNeedResearchAttention: 'report(s) need research attention.',
  reviewIncompleteReports: 'Review incomplete reports ›',
  clientsRiskOverview: 'Clients Risk Overview',
  reportsStatusOverview: 'Reports Status Overview',
  viewAndManageTheReportsYouAreResponsibleFor:
    'View and manage the reports you are responsible for.',
  generateNewReport2: '+ Generate New Report',
  organizationNotFound: 'Organization not found',
  '404OrganizationNotFound': '404 Organization not found',
  theOrganizationYouAreLookingForMayHaveBeen:
    'The organization you are looking for may have been removed, renamed or may have never\n\t\t\t\t\t  existed.',
  teamNotFound: 'Team not found',
  '404TeamNotFound': '404 Team not found',
  goHome: 'Go home',
  inviteANewOfficerAndSetTheirRoleAnd: 'Invite a new officer and set their role and permissions.',
  enterTheOfficerSPersonalAndContactInformation:
    "Enter the officer's personal and contact information",
  setTheOfficerSRoleAndPermissions: "Set the officer's role and permissions.",
  forEachRoleADefaultSetOfPermissionsIs: 'For each role, a default set of permissions is defined.',
  sendAnInvitationEmailToTheOfficer: 'Send an invitation email to the officer.',
  activatingTheOfficerSAccount: "Activating the officer's account",
  theOfficerSAccountWillBeActivatedOnceThey:
    "The officer's account will be activated once they log in through the invitation email.",
  manageAndViewOrganizationEmployees: 'Manage and view organization employees',
  addOfficer: 'Add Officer',
  allOfficers: 'All Officers',
  loadingOfficers: 'Loading officers...',
  reportUnavailable: 'Report unavailable',
  thisReportMayStillBeGeneratingOrIsUnavailable:
    'This report may still be generating or is unavailable. Return to All Reports to check its status.',
  backToReports: 'Back to Reports',
  yourReportWillBeAvailableWhenGenerationIsComplete:
    'Your report will be available when generation is complete.',
  thisReportIsStillInDraftStateSubmitIt:
    'This report is still in draft state. Submit it to begin KYC processing.',
  continueToWizard: 'Continue to Wizard',
  reportDiscarded: 'Report discarded',
  failedToCreateReport: 'Failed to create report',
  pleaseTryAgainIfTheIssuePersistsContactSupport:
    'Please try again. If the issue persists, contact support.',
  informationDetails: 'Information Details',
  keyMembers: 'Key Members (',
  decisionRecorded: 'Decision recorded',
  officerDecision: 'Officer Decision',
  provisionalReviewRequired: 'Provisional · review required',
  webResearch: 'Web research',
  clientAccepted: 'Client accepted',
  clientRejected: 'Client rejected',
  reportFinalized: '· report finalized',
  decisionRationale: 'Decision rationale',
  explainWhyYouAcceptOrRejectThisClient: 'Explain why you accept or reject this client.',
  iAcknowledgeTheHighRiskAndAcceptResponsibilityFor:
    'I acknowledge the High risk and accept responsibility for this decision.',
  acceptanceRequiresReviewedFindings:
    'Wait for research to finish and review every finding before accepting.',
  profileSummary: 'Profile summary',
  researchIncomplete: 'Limited evidence coverage',
  allFindingsReviewed: 'All findings reviewed',
  acceptClient: 'Accept client',
  rejectClient: 'Reject client',
  viewUploadedDocumentsAndReviewTheirVerificationResults:
    'View uploaded documents and review their verification results.',
  documentType: 'Document Type',
  uploadedOn: 'Uploaded On',
  verificationResult: 'Verification Result',
  problems: 'Problems',
  verifiedChecks: 'Verified checks',
  problemsDetected: 'Problems Detected',
  unassessed: 'Unassessed',
  noProblemsDetectedByAvailableChecks: 'No problems detected by available checks',
  verificationHasNotBeenCompleted: 'Verification has not been completed',
  verificationDetails: 'Verification details',
  viewDocument: 'View Document ›',
  noDocumentsUploaded: 'No documents uploaded.',
  originalUploadedDocument: 'Original uploaded document',
  openDownloadOriginal: 'Open / download original ↗',
  unableToLoadResearchProgress: 'Unable to load research progress.',
  waitingForResearchProgress: 'Waiting for research progress…',
  researchCoverage: 'Research coverage ·',
  resultsCoverOnlyTheWebSourcesResearchedMissingFindings:
    'Results cover only the web sources researched. Missing findings do not establish that a subject is clear.',
  retryIncompleteResearch: 'Retry incomplete research',
  researchedSources: 'Researched sources (',
  researchHistory: 'Research history',
  hideEvidence: 'Hide evidence',
  inspectEvidence: 'Inspect evidence',
  loadingEvidence: 'Loading evidence…',
  couldNotLoadEvidence: 'Could not load evidence.',
  retrieved: 'Retrieved',
  identityMatch: 'Identity match:',
  review: '· Review:',
  officerRationale: 'Officer rationale:',
  reviewRationale: 'Review rationale',
  iVerifiedThatThisEvidenceConcernsThisSubject:
    'I verified that this evidence concerns this subject.',
  confirmFinding: 'Confirm finding',
  dismissFinding: 'Dismiss finding',
  professionalSocialContext: 'Professional & Social Context',
  keyPeople2: 'Key People',
  keyStakeholdersMembers: 'Key Stakeholders & Members',
  previousMembers: 'Previous members',
  nextMembers: 'Next members',
  personalInformation: 'Personal information',
  noKeyMembersRecorded: 'No key members recorded.',
  viewStakeholderFullKycResult: 'View stakeholder full KYC result ›',
  webSearchQueries: 'Web Search Queries (',
  confirmed: 'Confirmed',
  dismissed: 'Dismissed',
  reportProcessing: 'Report Processing',
  theReportIsBeingGeneratedThisMayTakeA:
    'The report is being generated. This may take a few minutes.',
  reportNavigation: 'Report navigation',
  previousReport: '‹ Previous Report',
  nextReport: 'Next Report ›',
  reportFor: 'Report for',
  generatedByRavenOn: 'Generated by Raven on',
  viewClientProfile: 'View Client Profile ›',
  provisionalAssessment: 'Provisional assessment',
  researchCoverageSourcesProcessingHistory: 'Research coverage, sources & processing history',
  noIssuesDetectedInResearchedSources: 'No issues detected in researched sources',
  notSufficientlyAssessed: 'Not sufficiently assessed',
  issue: 'issue',
  detected: 'detected',
  findingsAcrossPublicProfilesBusinessSources: 'Findings Across Public Profiles & Business Sources',
  noSupportedSocialFindings: 'No supported social findings',
  verifiedAssociationsDiscrepanciesAndRiskIndicatorsAreDistinguishedBelow:
    'Verified associations, discrepancies, and risk indicators are distinguished below.',
  informational: 'Informational · ',
  reviewEvidenceFor: 'Review evidence for',
  noSupportedFindingsAreAvailableInThisCategory:
    'No supported findings are available in this category.',
} as const;
export const fa: Record<keyof typeof en, string> = {
  signInToYourAccount: 'ورود به حساب کاربری',
  welcomeBackWeAreLuckyToHaveYou: 'خوش آمدید.',
  donTHaveAnAccount: 'حساب کاربری ندارید؟',
  signUp: 'ثبت‌نام',
  uhOhLooksLikeYouReMissingAToken: 'لینک تأیید ناقص است',
  itSeemsThatThereIsNoTokenProvidedIf:
    'برای تأیید ایمیل، از لینکی که برایتان ارسال شده استفاده کنید.',
  goBackHome: 'بازگشت به صفحه اصلی',
  forgotYourPassword: 'رمز عبور را فراموش کرده‌اید؟',
  noWorriesItHappensEnterYourEmailAndWe:
    'ایمیل خود را وارد کنید تا لینک بازیابی رمز عبور برایتان ارسال شود.',
  rememberedYourPassword: 'رمز عبورتان را به خاطر آوردید؟',
  signIn: 'ورود',
  unableToResetPassword: 'بازیابی رمز عبور انجام نشد',
  theTokenYouHaveUsedToResetYourPassword:
    'لینک بازیابی معتبر نیست یا منقضی شده است. لطفاً لینک جدیدی درخواست کنید.',
  returnToSignIn: 'بازگشت به صفحه ورود',
  somethingWentWrong: 'مشکلی پیش آمد',
  weWereUnableToVerifyYourEmailAtThis: 'در حال حاضر امکان تأیید ایمیل وجود ندارد.',
  weWereUnableToVerifyYourEmailIfYour:
    'ایمیل تأیید نشد. اگر قبلاً آن را تأیید نکرده‌اید، دوباره تلاش کنید.',
  yourTokenHasExpired: 'لینک تأیید منقضی شده است',
  itSeemsThatTheProvidedTokenHasExpiredWe:
    'لینک جدیدی برایتان ارسال کردیم. لطفاً ایمیل خود را بررسی کنید.',
  emailConfirmed: 'ایمیل تأیید شد',
  yourEmailHasBeenSuccessfullyConfirmedYouCanNow:
    'ایمیل شما تأیید شد. اکنون می‌توانید از امکانات Raven استفاده کنید.',
  continue: 'ادامه',
  emailAlreadyConfirmed: 'ایمیل قبلاً تأیید شده است',
  yourEmailHasAlreadyBeenConfirmedYouCanNow:
    'ایمیل شما قبلاً تأیید شده است. می‌توانید از امکانات Raven استفاده کنید.',
  accountActivated: 'حساب فعال شد',
  yourAccountHasBeenActivatedRedirecting: 'حساب شما فعال شد. در حال انتقال…',
  activationFailed: 'فعال‌سازی انجام نشد',
  invitationExpired: 'دعوت‌نامه منقضی شده است',
  yourInvitationLinkHasExpiredPleaseContactYourOrganization:
    'برای دریافت دعوت‌نامه جدید با مدیر سازمان خود تماس بگیرید.',
  goToSignIn: 'ورود به حساب',
  invalidInvitation: 'دعوت‌نامه نامعتبر',
  thisInvitationLinkIsInvalidOrHasAlreadyBeen: 'این لینک دعوت معتبر نیست یا قبلاً استفاده شده است.',
  accountActivated2: 'حساب فعال شد',
  yourAccountHasBeenSuccessfullyActivatedYouWillBe:
    'حساب شما فعال شد. تا چند لحظه دیگر منتقل می‌شوید.',
  activateYourAccount: 'فعال‌سازی حساب کاربری',
  enterYourEmailAndSetAPasswordToActivate:
    'ایمیل خود را وارد کنید و برای حساب خود رمز عبور تعیین کنید.',
  emailAddress: 'آدرس ایمیل',
  password: 'رمز عبور',
  confirmPassword: 'تکرار رمز عبور',
  activateAccount: 'فعال‌سازی حساب',
  alreadyHaveAnAccount: 'قبلاً ثبت‌نام کرده‌اید؟',
  signIn2: 'ورود',
  registerNewOrganization: 'ثبت سازمان جدید',
  emailSent: 'ایمیل ارسال شد',
  aPasswordResetEmailHasBeenSentIfYou:
    'اگر با این ایمیل حسابی داشته باشید، لینک بازیابی رمز عبور برایتان ارسال می‌شود.',
  resetPassword: 'بازیابی رمز عبور',
  pleaseChooseYourNewPassword: 'رمز عبور جدید خود را وارد کنید',
  confirmEmail: 'تأیید ایمیل',
  toGainAccessToYourAccountPleaseConfirmYour:
    'برای دسترسی به حساب، روی لینک تأیید در ایمیل خود کلیک کنید.',
  ifYouDonTFindTheConfirmationLinkIn:
    'اگر ایمیل تأیید را دریافت نکرده‌اید، می‌توانید دوباره درخواست دهید.',
  mustBeAtLeast6CharactersInLength: 'حداقل ۶ کاراکتر وارد کنید',
  mustBeAtLeast8CharactersInLength: 'حداقل ۸ کاراکتر وارد کنید',
  cannotBeMoreThan72CharactersInLength: 'حداکثر ۷۲ کاراکتر مجاز است',
  oneUppercaseCharacter: 'یک حرف بزرگ انگلیسی',
  oneLowercaseCharacter: 'یک حرف کوچک انگلیسی',
  oneNumber: 'یک عدد',
  oneSpecialCharacterIsRequired: 'حداقل یک علامت مانند @ یا # وارد کنید',
  firstNameIsRequired: 'نام را وارد کنید',
  lastNameIsRequired: 'نام خانوادگی را وارد کنید',
  organizationNameIsRequired: 'نام سازمان را وارد کنید',
  passwordsDoNotMatch: 'رمز عبور و تکرار آن یکسان نیستند',
  theTokenNameShouldBe3CharactersOrLonger: 'نام کلید باید حداقل ۳ کاراکتر باشد',
  tokenCopiedToClipboard: 'کلید کپی شد',
  theTokenWasCopiedToYourClipboard: 'کلید در حافظه موقت کپی شد.',
  weWereUnableToCopyTheTokenToYour: 'کپی کلید انجام نشد. لطفاً دوباره تلاش کنید.',
  tokenCreated: 'کلید ایجاد شد',
  aNewTokenWasCreatedSuccessfully: 'کلید جدید با موفقیت ایجاد شد.',
  anErrorOccurred: 'خطایی رخ داد',
  tokenName: 'نام کلید',
  pleaseEnterAMeaningfulNameForYourTokenThis:
    'نامی انتخاب کنید که بعداً بتوانید کاربرد این کلید را تشخیص دهید.',
  tokenExpirationDate: 'تاریخ انقضای کلید',
  choose: 'انتخاب کنید…',
  neverExpire: 'بدون تاریخ انقضا',
  createToken: 'ایجاد کلید',
  yourTokenWasCreatedSuccessfullyMakeSureToCopy:
    'کلید ایجاد شد. آن را کپی و در جای امنی نگهداری کنید؛ امکان مشاهده دوباره آن وجود ندارد.',
  copyToken: 'کپی کلید',
  notSupported: 'پشتیبانی نمی‌شود',
  passkeysAreNotSupportedOnThisBrowser: 'این مرورگر از کلید عبور پشتیبانی نمی‌کند',
  unableToSignIn: 'ورود انجام نشد',
  thisAccountHasNotBeenVerifiedPleaseVerifyYour: 'ابتدا حساب خود را تأیید کنید و سپس وارد شوید.',
  weEncounteredAnUnknownErrorWhileAttemptingToSign:
    'ورود به حساب انجام نشد. لطفاً کمی بعد دوباره تلاش کنید.',
  signingIn: 'در حال ورود…',
  orContinueWith: 'یا ورود با',
  google: 'Google',
  twoFactorAuthentication: 'احراز هویت دومرحله‌ای',
  token: 'کد',
  backupCode: 'کد بازیابی',
  useBackupCode: 'استفاده از کد بازیابی',
  useAuthenticator: 'استفاده از برنامه احراز هویت',
  passwordShouldNotBeCommonOrBasedOnPersonal:
    'از رمزهای رایج یا اطلاعات شخصی در رمز عبور استفاده نکنید',
  registrationSuccessful: 'ثبت‌نام انجام شد',
  youHaveSuccessfullyRegisteredPleaseVerifyYourAccountBy:
    'برای تأیید حساب، روی لینکی که به ایمیل شما ارسال شده کلیک کنید.',
  organizationName: 'نام سازمان',
  acmeLtd: 'نام شرکت شما',
  country: 'کشور',
  optional: '(اختیاری)',
  eGUnitedKingdom: 'مثلاً ایران',
  description: 'توضیحات',
  oneOrTwoLinesAboutWhatYouDo: 'توضیح کوتاهی درباره فعالیت خود بنویسید',
  middleName: 'نام میانی',
  phoneNumber: 'شماره تلفن',
  emailAddress2: 'آدرس ایمیل',
  signInInstead: 'ورود به حساب موجود',
  createAccount: 'ایجاد حساب',
  byProceedingYouAgreeToOur: 'با ادامه، می‌پذیرید:',
  termsOfService: 'شرایط استفاده',
  and: 'و',
  privacyPolicy: 'حریم خصوصی',
  resetEmailSent: 'ایمیل بازیابی ارسال شد',
  sendingResetEmail: 'در حال ارسال ایمیل بازیابی…',
  passwordUpdated: 'رمز عبور تغییر کرد',
  yourPasswordHasBeenUpdatedSuccessfully: 'رمز عبور شما با موفقیت تغییر کرد.',
  currentPassword: 'رمز عبور فعلی',
  newPassword: 'رمز عبور جدید',
  repeatPassword: 'تکرار رمز عبور',
  updatingPassword: 'در حال تغییر رمز عبور…',
  updatePassword: 'تغییر رمز عبور',
  passwordsDonTMatch: 'رمز عبور و تکرار آن یکسان نیستند',
  resettingPassword: 'در حال بازیابی رمز عبور…',
  back: 'بازگشت',
  twoFactorAuthenticationDisabled: 'احراز هویت دومرحله‌ای غیرفعال شد',
  twoFactorAuthenticationHasBeenDisabledForYourAccount:
    'احراز هویت دومرحله‌ای حساب شما غیرفعال شد. از این پس برای ورود به کد برنامه احراز هویت نیاز ندارید.',
  unableToDisableTwoFactorAuthentication: 'غیرفعال‌سازی احراز هویت دومرحله‌ای انجام نشد',
  weWereUnableToDisableTwoFactorAuthenticationFor:
    'رمز عبور و کد بازیابی را بررسی کنید و دوباره تلاش کنید.',
  disable2fa: 'غیرفعال‌سازی تأیید دومرحله‌ای',
  pleaseProvideATokenFromTheAuthenticatorOrA:
    'کد برنامه احراز هویت یا یکی از کدهای بازیابی را وارد کنید. اگر به آن‌ها دسترسی ندارید، با پشتیبانی تماس بگیرید.',
  unableToSetupTwoFactorAuthentication: 'راه‌اندازی احراز هویت دومرحله‌ای انجام نشد',
  weWereUnableToSetupTwoFactorAuthenticationFor: 'کد واردشده را بررسی کنید و دوباره تلاش کنید.',
  twoFactorAuthenticationEnabled: 'احراز هویت دومرحله‌ای فعال شد',
  youWillNowBeRequiredToEnterACode:
    'از این پس هنگام ورود، باید کد برنامه احراز هویت را هم وارد کنید.',
  enable2fa: 'فعال‌سازی تأیید دومرحله‌ای',
  backupCodes: 'کدهای بازیابی',
  yourRecoveryCodesAreListedBelowPleaseStoreThem: 'کدهای بازیابی زیر را در جای امنی نگهداری کنید.',
  close: 'بستن',
  download: 'دانلود',
  enableAuthenticatorApp: 'فعال‌سازی برنامه احراز هویت',
  toEnableTwoFactorAuthenticationScanTheFollowingQr:
    'برای فعال‌سازی تأیید دومرحله‌ای، کد QR زیر را با برنامه احراز هویت اسکن کنید.',
  ifYourAuthenticatorAppDoesNotSupportQrCodes:
    'اگر برنامه شما از QR پشتیبانی نمی‌کند، کد زیر را وارد کنید:',
  onceYouHaveScannedTheQrCodeOrEntered:
    'پس از افزودن حساب به برنامه، کدی را که برنامه نمایش می‌دهد در قسمت زیر وارد کنید.',
  recoveryCodeCopied: 'کد بازیابی کپی شد',
  yourRecoveryCodeHasBeenCopiedToYourClipboard: 'کد بازیابی در حافظه موقت کپی شد.',
  unableToCopyRecoveryCode: 'کد بازیابی کپی نشد',
  weWereUnableToCopyYourRecoveryCodeTo: 'کپی کد بازیابی انجام نشد. دوباره تلاش کنید.',
  tokenIsRequired: 'کد را وارد کنید',
  viewCodes: 'مشاهده کدها',
  viewRecoveryCodes: 'مشاهده کدهای بازیابی',
  pleaseProvideATokenFromYourAuthenticatorOrA:
    'کد برنامه احراز هویت یا یکی از کدهای بازیابی را وارد کنید.',
  invalidCodePleaseTryAgain: 'کد معتبر نیست. دوباره تلاش کنید.',
  view: 'مشاهده',
  or: 'یا',
  confirmationEmailSent: 'ایمیل تأیید ارسال شد',
  aConfirmationEmailHasBeenSentAndItShould:
    'ایمیل تأیید ارسال شد و تا چند لحظه دیگر به دستتان می‌رسد.',
  anErrorOccurredWhileSendingYourConfirmationEmail: 'ایمیل تأیید ارسال نشد',
  pleaseTryAgainAndMakeSureYouEnterThe: 'از درست بودن آدرس ایمیل مطمئن شوید و دوباره تلاش کنید.',
  sendConfirmationEmail: 'ارسال ایمیل تأیید',
  viewOrganizationClients: 'مشاهده مشتریان سازمان',
  viewOrganizationAllCreatedReports: 'مشاهده همه گزارش‌های سازمان',
  approveRejectClients: 'تأیید یا رد مشتریان',
  createKycAndKybReports: 'تهیه گزارش‌های KYC و KYB',
  viewAndManageOwnReports: 'مشاهده و مدیریت گزارش‌های خود',
  viewAndManageClientsAddByThemselves: 'مشاهده و مدیریت مشتریان ثبت‌شده توسط خود',
  createKycReports: 'تهیه گزارش KYC',
  createKybReports: 'تهیه گزارش KYB',
  permissionsFor: 'دسترسی‌های',
  briefDescriptionOfTheOrganization: 'توضیح کوتاهی درباره سازمان',
  pleaseSelectAUser: 'یک کاربر انتخاب کنید',
  newUser: 'کاربر جدید',
  existingUser: 'کاربر موجود',
  searchByEmail: 'جست‌وجو با ایمیل…',
  searching: 'در حال جست‌وجو…',
  noUsersFound: 'کاربری پیدا نشد',
  manageOrganizationOwnersAndTheirAccountStatus: 'مدیریت مالکان سازمان و وضعیت حساب آن‌ها',
  refresh: 'به‌روزرسانی',
  allOwners: 'همه مالکان',
  loadingOwners: 'در حال بارگیری مالکان…',
  failedToSendInvitation: 'دعوت‌نامه ارسال نشد',
  createOrganizationOwner: 'ایجاد سازمان و تعیین مالک',
  setUpANewOrganizationAndAssignAnOwner: 'سازمان جدید را ایجاد کنید و مالک آن را مشخص کنید.',
  subject: 'موضوع',
  body: 'متن',
  sendEmail: 'ارسال ایمیل',
  invitationSentSuccessfully: 'دعوت‌نامه ارسال شد',
  theInvitationEmailWasSuccessfullySentTo: 'دعوت‌نامه ارسال شد برای',
  pendingActivation: 'در انتظار فعال‌سازی',
  exit: 'خروج',
  enterTheOrganizationSNameAndCountry: 'نام و کشور سازمان را وارد کنید.',
  assignOwnerToOrganization: 'مالک سازمان را تعیین کنید.',
  sendAnInvitationEmailToTheOwner: 'برای مالک دعوت‌نامه بفرستید.',
  pleaseReviewAndConfirmTheEmailContent: 'متن ایمیل را بررسی و تأیید کنید.',
  activatingTheOwnerSAccount: 'فعال‌سازی حساب مالک',
  theOrganizationAccountWillBeActivatedUponTheOwner:
    'حساب سازمان با اولین ورود مالک از طریق دعوت‌نامه فعال می‌شود.',
  manageSystemOrganizationsAndTheirAccountStatus: 'مدیریت سازمان‌ها و وضعیت حساب آن‌ها',
  addOrganization: 'افزودن سازمان',
  allOrganizations: 'همه سازمان‌ها',
  loadingOrganizations: 'در حال بارگیری سازمان‌ها…',
  customizeTheAppearanceOfTheAppAutomaticallySwitchBetween:
    'پوسته روشن، تیره یا هماهنگ با تنظیمات دستگاه را انتخاب کنید.',
  hereYouCanManageYourPasswordAndSecuritySettings: 'رمز عبور و تنظیمات امنیتی حساب را مدیریت کنید.',
  security: 'امنیت',
  hereYouCanManageYourTwoFactorAuthenticationSettings:
    'تنظیمات احراز هویت دومرحله‌ای را مدیریت کنید.',
  twoFactorAuthentication2: 'احراز هویت دومرحله‌ای',
  addAnAuthenticatorToServeAsASecondaryAuthentication:
    'برای افزایش امنیت ورود، برنامه احراز هویت را به حساب خود اضافه کنید.',
  recoveryCodes: 'کدهای بازیابی',
  twoFactorAuthenticationRecoveryCodesAreUsedToAccess:
    'اگر به برنامه احراز هویت دسترسی نداشتید، می‌توانید با کدهای بازیابی وارد حساب خود شوید.',
  manageYourPasskeys: 'کلیدهای عبور خود را مدیریت کنید.',
  passkeys: 'کلیدهای عبور',
  onThisPageYouCanCreateAndManageApi:
    'در این صفحه کلیدهای API را ایجاد و مدیریت کنید. راهنمای بیشتر در',
  documentation: 'مستندات',
  forMoreInformation: 'در دسترس است.',
  unauthorized: 'دسترسی مجاز نیست',
  youNeedToBeAnOwnerToManageApi: 'فقط مالک سازمان می‌تواند کلیدهای API را مدیریت کند.',
  yourExistingTokens: 'کلیدهای شما',
  yourTokensWillBeShownHereOnceYouCreate: 'کلیدهای ایجادشده اینجا نمایش داده می‌شوند.',
  createdOn: 'تاریخ ایجاد',
  expiresOn: 'تاریخ انقضا',
  tokenDoesnTHaveAnExpirationDate: 'این کلید تاریخ انقضا ندارد',
  activity: 'فعالیت‌ها',
  unreadNotifications: 'اعلان خوانده‌نشده',
  viewReport: 'مشاهده گزارش',
  markUnread: 'علامت‌گذاری به‌عنوان خوانده‌نشده',
  markRead: 'علامت‌گذاری به‌عنوان خوانده‌شده',
  noNotificationsYet: 'هنوز اعلانی ندارید.',
  generateNewReport: 'تهیه گزارش جدید',
  backToClients: 'بازگشت به مشتریان',
  previousClient: 'مشتری قبلی',
  nextClient: 'مشتری بعدی',
  seeTheClientDetails: 'جزئیات مشتری',
  comprehensiveInformationAboutTheClientReviewProgressAndSubmitted:
    'اطلاعات مشتری، وضعیت بررسی و مدارک ارسالی',
  viewLatestReport: 'مشاهده آخرین گزارش',
  clientSections: 'بخش‌های پرونده مشتری',
  profile: 'مشخصات',
  keyPeople: 'افراد کلیدی',
  reviewHistory: 'سوابق بررسی',
  documents: 'مدارک',
  generatedReports: 'گزارش‌های تهیه‌شده',
  clientId: 'شناسه مشتری:',
  removeBookmark: 'حذف از نشان‌شده‌ها',
  bookmarkClient: 'نشان کردن مشتری',
  firstSubmissionDate: 'تاریخ اولین ثبت',
  lastReviewDate: 'تاریخ آخرین بررسی',
  ravenReviewSummary: 'خلاصه بررسی Raven',
  riskLevelIs: 'میزان ریسک:',
  generatedReports2: 'گزارش‌های تهیه‌شده',
  reviewHistory2: 'سوابق بررسی',
  timelineOfGeneratedReportsAndDetectedRiskLevels: 'روند زمانی گزارش‌ها و میزان ریسک شناسایی‌شده',
  viewReportRiskResultsOverTime: 'مشاهده روند ریسک گزارش‌ها',
  reviewHistoryPeriod: 'بازه سوابق بررسی',
  riskSignalsBasedOnSelectedReport: 'موارد ریسک در گزارش انتخاب‌شده',
  viewReport2: 'مشاهده گزارش',
  allReportsGeneratedForThisClientSReview: 'همه گزارش‌های بررسی این مشتری',
  savedClients: 'مشتریان ذخیره‌شده',
  allClients: 'همه مشتریان',
  addNewClient: '+ افزودن مشتری',
  viewAndManageTheClientsYouAreResponsibleFor: 'مشتریان تحت مسئولیت خود را مشاهده و مدیریت کنید.',
  clientType: 'نوع مشتری',
  myClients: 'مشتریان من',
  clientsFound: 'مشتری پیدا شد',
  viewClient: 'مشاهده مشتری',
  noBookmarkedClients: 'مشتری نشان‌شده‌ای ندارید.',
  noAcceptedClientsMatchYourSearch: 'مشتری تأییدشده‌ای با این مشخصات پیدا نشد.',
  clients: 'مشتری',
  totalReports: 'تعداد گزارش‌ها',
  totalClients: 'تعداد مشتریان',
  reportsInProgress: 'گزارش‌های در حال تهیه',
  pendingReports: 'گزارش‌های در انتظار بررسی',
  ravenKycDashboard: 'داشبورد شناخت مشتری',
  welcomeBack: 'خوش آمدید،',
  monitorClientsKycFlowAtAGlance: 'وضعیت بررسی مشتریان را در یک نگاه ببینید.',
  dashboardPeriod: 'بازه زمانی داشبورد',
  createANewReport: 'تهیه گزارش جدید',
  beginReviewingANewClient: 'بررسی مشتری جدید را شروع کنید.',
  createReport: 'ایجاد گزارش',
  reportSNeedResearchAttention: 'گزارش به بررسی بیشتر نیاز دارد.',
  reviewIncompleteReports: 'مشاهده گزارش‌های ناقص',
  clientsRiskOverview: 'نمای کلی ریسک مشتریان',
  reportsStatusOverview: 'نمای کلی وضعیت گزارش‌ها',
  viewAndManageTheReportsYouAreResponsibleFor: 'گزارش‌های تحت مسئولیت خود را مشاهده و مدیریت کنید.',
  generateNewReport2: '+ تهیه گزارش جدید',
  organizationNotFound: 'سازمان پیدا نشد',
  '404OrganizationNotFound': '۴۰۴ ـ سازمان پیدا نشد',
  theOrganizationYouAreLookingForMayHaveBeen:
    'سازمان موردنظر پیدا نشد. ممکن است حذف شده یا نام آن تغییر کرده باشد.',
  teamNotFound: 'تیم پیدا نشد',
  '404TeamNotFound': '۴۰۴ ـ تیم پیدا نشد',
  goHome: 'صفحه اصلی',
  inviteANewOfficerAndSetTheirRoleAnd: 'کارشناس جدید را دعوت و نقش و دسترسی‌های او را مشخص کنید.',
  enterTheOfficerSPersonalAndContactInformation: 'اطلاعات فردی و تماس کارشناس را وارد کنید',
  setTheOfficerSRoleAndPermissions: 'نقش و دسترسی‌های کارشناس را مشخص کنید.',
  forEachRoleADefaultSetOfPermissionsIs: 'برای هر نقش، دسترسی‌های پیش‌فرض تعریف شده است.',
  sendAnInvitationEmailToTheOfficer: 'برای کارشناس دعوت‌نامه بفرستید.',
  activatingTheOfficerSAccount: 'فعال‌سازی حساب کارشناس',
  theOfficerSAccountWillBeActivatedOnceThey: 'حساب کارشناس با ورود از طریق دعوت‌نامه فعال می‌شود.',
  manageAndViewOrganizationEmployees: 'مشاهده و مدیریت اعضای سازمان',
  addOfficer: 'افزودن کارشناس',
  allOfficers: 'همه کارشناسان',
  loadingOfficers: 'در حال بارگیری کارشناسان…',
  reportUnavailable: 'گزارش در دسترس نیست',
  thisReportMayStillBeGeneratingOrIsUnavailable:
    'ممکن است گزارش هنوز در حال تهیه باشد. وضعیت آن را در فهرست گزارش‌ها بررسی کنید.',
  backToReports: 'بازگشت به گزارش‌ها',
  yourReportWillBeAvailableWhenGenerationIsComplete: 'گزارش پس از تکمیل در دسترس قرار می‌گیرد.',
  thisReportIsStillInDraftStateSubmitIt: 'این گزارش پیش‌نویس است. برای شروع بررسی، آن را ثبت کنید.',
  continueToWizard: 'ادامه مراحل',
  reportDiscarded: 'پیش‌نویس حذف شد',
  failedToCreateReport: 'گزارش ایجاد نشد',
  pleaseTryAgainIfTheIssuePersistsContactSupport:
    'دوباره تلاش کنید. اگر مشکل ادامه داشت، با پشتیبانی تماس بگیرید.',
  informationDetails: 'جزئیات اطلاعات',
  keyMembers: 'افراد کلیدی (',
  decisionRecorded: 'تصمیم ثبت شد',
  officerDecision: 'تصمیم کارشناس',
  provisionalReviewRequired: 'موقت · نیازمند بررسی',
  webResearch: 'جست‌وجوی وب',
  clientAccepted: 'مشتری تأیید شد',
  clientRejected: 'مشتری رد شد',
  reportFinalized: '· گزارش نهایی شد',
  decisionRationale: 'دلیل تصمیم',
  explainWhyYouAcceptOrRejectThisClient: 'دلیل تأیید یا رد مشتری را بنویسید.',
  iAcknowledgeTheHighRiskAndAcceptResponsibilityFor:
    'از ریسک بالای این مورد آگاه هستم و مسئولیت این تصمیم را می‌پذیرم.',
  acceptanceRequiresReviewedFindings:
    'برای تأیید، منتظر پایان جست‌وجو بمانید و وضعیت همه یافته‌ها را مشخص کنید.',
  profileSummary: 'خلاصه پروفایل',
  researchIncomplete: 'پوشش محدود شواهد',
  allFindingsReviewed: 'همه یافته‌ها بررسی شدند',
  acceptClient: 'تأیید مشتری',
  rejectClient: 'رد مشتری',
  viewUploadedDocumentsAndReviewTheirVerificationResults:
    'مدارک بارگذاری‌شده و نتایج اعتبارسنجی آن‌ها را بررسی کنید.',
  documentType: 'نوع مدرک',
  uploadedOn: 'تاریخ بارگذاری',
  verificationResult: 'نتیجه اعتبارسنجی',
  problems: 'مشکلات',
  verifiedChecks: 'بررسی‌های تأییدشده',
  problemsDetected: 'مشکلات شناسایی‌شده',
  unassessed: 'بررسی‌نشده',
  noProblemsDetectedByAvailableChecks: 'در بررسی‌های انجام‌شده مشکلی شناسایی نشد',
  verificationHasNotBeenCompleted: 'اعتبارسنجی تکمیل نشده است',
  verificationDetails: 'جزئیات اعتبارسنجی',
  viewDocument: 'مشاهده مدرک',
  noDocumentsUploaded: 'مدرکی بارگذاری نشده است.',
  originalUploadedDocument: 'اصل مدرک بارگذاری‌شده',
  openDownloadOriginal: 'مشاهده یا دانلود اصل مدرک ↗',
  unableToLoadResearchProgress: 'وضعیت جست‌وجو بارگیری نشد.',
  waitingForResearchProgress: 'در انتظار شروع جست‌وجو…',
  researchCoverage: 'پوشش بررسی ·',
  resultsCoverOnlyTheWebSourcesResearchedMissingFindings:
    'نتایج فقط مربوط به منابع بررسی‌شده هستند. نبود یافته به معنی نبود ریسک نیست.',
  retryIncompleteResearch: 'تلاش دوباره برای بررسی‌های ناقص',
  researchedSources: 'منابع بررسی‌شده (',
  researchHistory: 'سوابق جست‌وجو',
  hideEvidence: 'پنهان کردن شواهد',
  inspectEvidence: 'مشاهده شواهد',
  loadingEvidence: 'در حال بارگیری شواهد…',
  couldNotLoadEvidence: 'شواهد بارگیری نشدند.',
  retrieved: 'دریافت‌شده در',
  identityMatch: 'تطبیق هویت:',
  review: '· بررسی:',
  officerRationale: 'دلیل کارشناس:',
  reviewRationale: 'دلیل بررسی',
  iVerifiedThatThisEvidenceConcernsThisSubject:
    'تأیید می‌کنم که این شواهد مربوط به همین شخص یا شرکت است.',
  confirmFinding: 'تأیید یافته',
  dismissFinding: 'رد یافته',
  professionalSocialContext: 'سوابق حرفه‌ای و اجتماعی',
  keyPeople2: 'افراد کلیدی',
  keyStakeholdersMembers: 'ذی‌نفعان و افراد کلیدی',
  previousMembers: 'اعضای قبلی',
  nextMembers: 'اعضای بعدی',
  personalInformation: 'اطلاعات فردی',
  noKeyMembersRecorded: 'فرد کلیدی ثبت نشده است.',
  viewStakeholderFullKycResult: 'مشاهده نتیجه کامل بررسی فرد',
  webSearchQueries: 'عبارت‌های جست‌وجوی وب (',
  confirmed: 'تأییدشده',
  dismissed: 'ردشده',
  reportProcessing: 'در حال تهیه گزارش',
  theReportIsBeingGeneratedThisMayTakeA: 'تهیه گزارش ممکن است چند دقیقه طول بکشد.',
  reportNavigation: 'پیمایش گزارش‌ها',
  previousReport: 'گزارش قبلی',
  nextReport: 'گزارش بعدی',
  reportFor: 'گزارش مربوط به',
  generatedByRavenOn: 'تهیه‌شده توسط Raven در',
  viewClientProfile: 'مشاهده پرونده مشتری',
  provisionalAssessment: 'ارزیابی موقت',
  researchCoverageSourcesProcessingHistory: 'پوشش بررسی، منابع و سوابق پردازش',
  noIssuesDetectedInResearchedSources: 'در منابع بررسی‌شده موردی شناسایی نشد',
  notSufficientlyAssessed: 'بررسی کافی انجام نشده است',
  issue: 'مورد',
  detected: 'شناسایی شد',
  findingsAcrossPublicProfilesBusinessSources: 'یافته‌های منابع عمومی و تجاری',
  noSupportedSocialFindings: 'یافته اجتماعی مستندی وجود ندارد',
  verifiedAssociationsDiscrepanciesAndRiskIndicatorsAreDistinguishedBelow:
    'ارتباطات تأییدشده، مغایرت‌ها و نشانه‌های ریسک در ادامه تفکیک شده‌اند.',
  informational: 'جهت اطلاع ·',
  reviewEvidenceFor: 'بررسی شواهد مربوط به',
  noSupportedFindingsAreAvailableInThisCategory: 'در این دسته، یافته مستندی وجود ندارد.',
};
